<template>
  <div class="account">
    <div class="filter">
      <el-form :inline="true">
        <el-form-item label="账号名称：">
          <el-input
            v-model="model.nickname"
            placeholder="请输入账号名称"
            @change="getData"
            clearable
          />
        </el-form-item>
        <el-form-item label="数据范围：">
          <el-select
            v-model="model.parkIds"
            placeholder="请选择数据范围"
            @change="getData"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="body">
      <div class="handle">
        <el-button
          type="success"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
        >
          添 加
        </el-button>
        <el-button type="info" icon="el-icon-refresh-left" @click="handleReset">
          重置
        </el-button>
        <el-button type="danger" icon="el-icon-delete" @click="batchDelete">
          删 除
        </el-button>
      </div>
      <div class="table-container">
        <el-table
          v-loading="tableLoading"
          :data="tableList"
          @selection-change="selectionChange"
          :height="windowHeight"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column label="姓名" prop="nickname" />
          <el-table-column label="电话" prop="phone" />
          <el-table-column label="园区" prop="parkStr" />
          <el-table-column label="备注" prop="remark" />
          <el-table-column label="操作" width="55">
            <template slot-scope="{ row }">
              <i class="el-icon-edit handle-edit" @click="handleEdit(row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pager">
        <el-pagination
          :current-page="pageData.page"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="pageData.pageSize"
          :total="total"
          @size-change="sizeChange"
          @current-change="currChange"
          layout="total, sizes, prev, pager, next, jumper"
        />
      </div>
    </div>
    <el-dialog :visible.sync="visible" @close="handleCancel">
      <div class="visibleRefuse">
        <div class="title">保安信息录入</div>
        <div class="content">
          <el-form
            :model="form"
            :rules="rules"
            ref="hook-form"
            :inline="true"
            class="form"
          >
            <el-form-item
              label="姓名："
              label-width="80px"
              class="form_item1"
              prop="nickname"
            >
              <el-input v-model="form.nickname" placeholder="请输入姓名" />
            </el-form-item>
            <el-form-item
              label="电话："
              label-width="80px"
              class="form_item1"
              prop="phone"
            >
              <el-input v-model="form.phone" placeholder="请输入电话" />
            </el-form-item>
            <el-form-item
              label="园区："
              label-width="80px"
              prop="parkList"
              class="form_item1"
            >
              <el-select
                v-model="form.parkList"
                placeholder="请选择园区"
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="备注：" label-width="80px" class="form_item2">
              <el-input
                v-model="form.remark"
                type="textarea"
                :rows="4"
                style="max-width: 100%"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel" class="cancel">取 消</el-button>
        <el-button
          class="submit"
          :loading="btnLoading"
          type="primary"
          @click="handleSubmit"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis";

export default {
  name: "securityManage",
  props: ["queryRoleAllot"],
  data() {
    return {
      tableLoading: false,
      btnLoading: false,
      model: {
        nickname: "",
        parkIds: ""
      },
      pageData: {
        page: 1,
        pageSize: 20
      },
      options: [],
      tableList: [],
      selection: [],
      total: 0,
      visible: false,
      handleType: "add",
      form: {
        nickname: "",
        username: "",
        phone: "",
        parkList: [],
        remark: ""
      },
      rules: {
        nickname: [{ required: true, message: "请输入姓名" }],
        phone: [
          { required: true, validator: this.validatePhone, trigger: "blur" }
        ],
        parkList: [{ required: true, message: "请选择园区" }]
      },
      windowHeight: 350
    };
  },
  watch: {
    model: function () {
      this.pageData.page = 1;
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.getData();
    this.getOptions();
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 280;
      });
    },
    // 电话验证
    validatePhone(rule, value, callback) {
      console.log(rule);
      if (value === "") {
        callback(new Error("请输入电话"));
      } else {
        if (value !== "") {
          var reg = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/;

          if (!reg.test(value)) {
            callback(new Error("请输入正确的手机号"));
          }
        }

        callback();
      }
    },
    selectionChange(v) {
      this.selection = v;
    },
    //重置
    resetForm() {
      this.form = {
        nickname: "",
        username: "",
        phone: "",
        parkList: [],
        remark: ""
      };
    },
    // 删除
    batchDelete() {
      const ids = this.selection.map(item => item.id);
      if (!ids.length) {
        return this.$message.warning("请选择需要删除的账号");
      }

      this.$confirm("是否确认删除?")
        .then(() => {
          apis.parkUserDelete({ ids }).then(() => {
            this.$message.success("删除成功!");
            this.getData();
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //添加
    handleAdd() {
      this.resetForm();
      this.visible = true;
      this.handleType = "add";
      this.$refs["hook-form"].resetFields();
    },
    //重置
    handleReset() {
      this.model = {
        nickname: "",
        parkIds: ""
      };
      this.getData();
    },
    //编辑
    handleEdit(row) {
      const { username, nickname, parkList, phone, remark, id } = row;
      this.form = {
        username,
        nickname,
        parkList,
        phone,
        remark,
        id
      };
      this.visible = true;
      this.handleType = "edit";
    },
    //取消添加
    handleCancel() {
      this.visible = false;
      this.$refs["hook-form"].resetFields();
    },
    //确认添加
    handleSubmit() {
      this.$refs["hook-form"].validate().then(valid => {
        if (valid) {
          this.btnLoading = true;
          apis
            .parkUserAddOrUpdate({
              ...this.form,
              type: 2,
              dataType: 1,
              username: this.form.nickname
            })
            .then(() => {
              this.visible = false;
              this.getData();
              this.queryRoleAllot(sessionStorage.getItem("username"));
              this.$message.success("录入成功!");
            })
            .finally(() => (this.btnLoading = false));
        }
      });
    },
    sizeChange(value) {
      this.pageData.pageSize = value;
      this.getData();
    },
    currChange(value) {
      this.pageData.page = value;
      this.getData();
    },
    // 园区列表
    getOptions() {
      apis.parkQueryAll({ type: 1 }).then(({ data }) => {
        this.options = data;
      });
    },
    //列表数据
    getData() {
      this.tableLoading = true;
      apis
        .parkUserList({
          ...this.pageData,
          ...this.model,
          type: 2
        })
        .then(({ data, total }) => {
          this.tableList = data;
          this.total = total;
          this.tableLoading = false
        })
        .finally(() => (this.tableLoading = false));
    }
  }
};
</script>

<style lang="scss" scoped>
.account {
  height: calc(100vh - 77px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }
}
.handle {
  margin-bottom: 15px;
}
.table-container {
  margin-bottom: 20px;
}
.handle-edit {
  cursor: pointer;
}
.pager {
  display: flex;
  justify-content: flex-end;
}

.form {
  ::v-deep {
    .el-form-item__label {
      padding-right: 0;
    }
  }
  width: 100%;
  .form_item {
    width: 100%;
    ::v-deep {
      .el-form-item__content {
        width: calc(50% - 80px);
      }
    }
  }
  .form_item1 {
    width: 45%;
    ::v-deep {
      .el-form-item__content {
        width: calc(100% - 80px);
      }
    }
  }
  .form_item2 {
    width: 100%;
    ::v-deep {
      .el-form-item__content {
        width: calc(100% - 125px);
      }
    }
  }
  .form_item3 {
    ::v-deep {
      .el-input__inner {
        border: 0;
        &::placeholder {
          color: #048afb;
        }
      }
      .el-icon-arrow-up:before {
        content: "";
      }
    }
  }
}
.dialog-footer {
  .cancel {
    border: 1px solid #388654;
    color: #388654;
  }
  .submit {
    background: #388654;
    border: 1px solid #388654;
    color: #fff;
  }
}
.visibleRefuse {
  .title {
    line-height: 11px;
    height: 100%;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 11px;
    color: #18191e;
    margin-left: 5px;
    margin-top: -30px;
    &::before {
      content: "";
      display: inline-block;
      width: 2px;
      height: 11px;
      background: #388654;
      margin-right: 5px;
    }
  }
  .content {
    padding: 20px 10px 0 10px;
  }
}
</style>
